import { rectIsFullyWithinRect, point2Rect, checkLinkRectIntersection, getPointFromAngles } from 'lib/geom';
import { dragdrop } from 'lib/drag-drop';
import { regionUI } from 'lib/region-ui';

class SelectionUI {
  setCanvas(canvas) {
    this.canvas = canvas;
    this.nodeRects = {};
  }

  resetNodeRects() {
    this.nodeRects = {};
  }

  getNodeRect(node) {
    if (this.nodeRects[node.id]) return this.nodeRects[node.id];
    let nodeRect;
    if (node.getTopLevelParent().link()) {
      /*
        node.absolutePosition isn't accurate for link nodes due
        it being written in placeLinkNode, and getting a css transform: translateX: 50% applied
      */
      const { x, y, height, width } = this.canvas.getNodeTag({ id: node.id }).getRenderedPosition();
      nodeRect = {
        top: y,
        left: x,
        bottom: y + height,
        right: x + width,
      };
    } else {
      const x = node.absolutePosition.x;
      const y = node.absolutePosition.y;
      const height = node.height || 0;
      const width = node.width || 0;
      nodeRect = {
        top: y,
        left: x,
        bottom: y + height,
        right: x + width,
      };
    }

    this.nodeRects[node.id] = nodeRect;
    return nodeRect;
  }

  isNodeInBounds(node, box) {
    const { left, right, top, bottom } = box;

    const nodeRect = this.getNodeRect(node);

    const selectionRect = {
      top,
      left,
      bottom,
      right,
    };
    /*
      don't select freehand container if selecting cards inside it.
      no hit if box is contained within node
    */
    if (dragdrop.isContainedIn({dragging: nodeRect, target: box, spillover: 0})) {
      return;
    }
    return dragdrop.hit(selectionRect, nodeRect);
  }

  getNodesInsideBox(box) {
    const { left, right, top, bottom } = box;
    const nodes = [];
    for (let node of this.canvas.store.getNodes()) {
      const nodeTag = this.canvas.nodeTags[node.id];

      const visibleAncestor = node.getFirstVisibleAncestorNode();

      if (this.isNodeInBounds(visibleAncestor, box)) {
        nodes.push(node);
      }
    }
    return nodes;
  }

  getRegionsInsideBox(box) {
    const { left, right, top, bottom } = box;
    const regions = [];
    for (let region of this.canvas.store.getRegions()) {

      if (dragdrop.isContainedIn({dragging: box, target: region, spillover: 10})) {
        regions.push(region);
      }
    }
    return regions;
  }

  selectAllInsideBox(box, dontDeselect) {
    const { left, right, top, bottom } = box;
    // items currently selected that we want to keep selected
    const stashedSelection = this.canvas.getStashedSelection();

    const regionsToSelect = this.getRegionsInsideBox(box);
    const regionIdsToSelect = regionsToSelect.map(r => r.id);
    regionUI.selectRegions(regionIdsToSelect);

    const allRegionIds = this.canvas.store.getRegions().map(r => r.id);

    const regionIdsToDeselect = dontDeselect ? [] : allRegionIds.filter(rId => !regionIdsToSelect.includes(rId));

    for (const rId of regionIdsToDeselect ) {
      if (stashedSelection[rId]) {
        continue;
      }

      regionUI.removeRegionFromSelection(rId);
    }

    for (let node of this.canvas.store.getNodes()) {
      const nodeTag = this.canvas.nodeTags[node.id];
      if (stashedSelection[node.id]) {
        continue;
      }

      const visibleAncestor = node.getFirstVisibleAncestorNode();

      if (this.isNodeInBounds(visibleAncestor, box)) {
        if (!this.canvas.isSelectedElement(node.id)) {
          this.canvas.setSelectedElement(nodeTag, true);
        }
      } else {

        if (this.canvas.isSelectedElement(node.id)) {
          if (!dontDeselect) {
            this.canvas.clearSelectedElement(nodeTag);
          }
        }
      }
    }

    for (let link of this.canvas.links) {
      if (!link.fromNode() || !link.toNode()) {
        // failsafe
        continue;
      }
      if (stashedSelection[link.id]) {
        continue;
      }
      if (!link.showArc()) {
        continue;
      }

      const linkTag = this.canvas.linkTags[link.id];

      const { fromPoint, toPoint, thirdPoint } = linkTag;
      const fromPointRect = point2Rect(fromPoint);
      const toPointRect = point2Rect(toPoint);
      const endPointContained = rectIsFullyWithinRect(fromPointRect, box)
        || rectIsFullyWithinRect(toPointRect, box);

      if (endPointContained || checkLinkRectIntersection({ link, linkTag, rect: box })) {
        if (!this.canvas.isSelectedElement(link.id)) {
          this.canvas.setSelectedElement(linkTag, true);
        }
      } else {
        if (this.canvas.isSelectedElement(link.id)) {
          if (!dontDeselect) {
            this.canvas.clearSelectedElement(linkTag);
          }
        }
      }
    }

    this.canvas.multiSelectionIndicatorBox.update();
  }
}

const selectionUI = new SelectionUI();
export { SelectionUI, selectionUI };



// WEBPACK FOOTER //
// ./starling/src/lib/selection-ui.js